import { send } from 'server';
import { initiateDocumentUpload, getJWTToken, checkInDotComListener } from '@core/js/hooks/usePublicAPI/hooks/useServerPublicAPI/server';

const checkIfUsernameIsAvailable = ({ token = null, casinoName, phone, ...params }) => send({ // @theme
	ID: 31003,
	description: 'Checks if username is available',
	responses: [31004, 33007],
	// @theme removed params
	casinoName,
	...token && { token },
	// #region @theme
	phone,
	...params
	// #endregion
});

export { initiateDocumentUpload, getJWTToken, checkInDotComListener, checkIfUsernameIsAvailable };
